import * as React from "react";
import {CSSProperties} from "react";
import Link from "gatsby-link";
import {Location} from "history";

/**
 * checks if a nav item is active based on a path prefix
 * @param prefix the path prefix (ie. "/docs/core")
 * @param location the router's current page location
 */
 function isNavItemActive(prefix: string, location: Location): boolean {
	return location.pathname.indexOf(prefix) === 0;
}

interface NavItemProps {
	link: string;
	activePrefix: any;
	title: string;
	style?: CSSProperties;
	activeStyle?: CSSProperties;
	href?: string;
	onClick(): void;
}

/**
 * displays a link in the header
 */
const NavItem = (props: NavItemProps) => {

	const style = {
		margin: "0 12px",
		fontFamily: "Outfit SB",
		color: "#001226",
		fontSize: '14px',
		letterSpacing: "1.5px",
		textTransform: "uppercase",
		...props.style,
	}

	return props.href ? 
	(<a className="nav-item" href={props.href} target="_blank" style={style}>{props.title}</a>)
	: (
	<Link
		className="nav-item"
		to={props.link}
		style={style}
		isActive={(match, location) => isNavItemActive(props.activePrefix, location)}
		activeStyle={{
			...props.activeStyle,
		}}
		onClick={() => props.onClick()}
	>
		{props.title}
	</Link>)
};

export default NavItem;


// WEBPACK FOOTER //
// ./src/components/NavItem.tsx